import { Upload } from '@mui/icons-material'
import { Button } from '@mui/material'
import { IVesselVisitItem } from '@planning/rt-stores/vesselVisit/VesselVisitItem'
import { useTranslate } from '@tolgee/react'
import { FC } from 'react'

export type VesselVisitOrderUploadButtonProps = {
  vesselVisitItem: IVesselVisitItem
  onClick: () => void
}

export const VesselVisitOrderUploadButton: FC<VesselVisitOrderUploadButtonProps> = ({
  vesselVisitItem,
  onClick,
}) => {
  const { t } = useTranslate()

  return (
    <Button
      variant='contained'
      color='primary'
      data-cy='upload-orders-btn'
      onClick={onClick}
      startIcon={<Upload />}
      disabled={vesselVisitItem.isVesselVisitBlockedForEdit}
    >
      {t('upload', 'Upload')}
    </Button>
  )
}
